import maxBy from 'lodash-es/maxBy'

import type { Order } from '../../__models__'

export const getOrderImageUrl = (
  offers: Order['offers'],
  offersCancelled: Order['offersCancelled'],
) => {
  const mostExpensiveOffer = maxBy(offers, 'price.value')?.offer
  const mostExpensiveCanceledOffer = maxBy(offersCancelled, 'price.value')?.offer

  if (mostExpensiveOffer) {
    return mostExpensiveOffer.thumbnailImage
  }

  if (mostExpensiveCanceledOffer) {
    return mostExpensiveCanceledOffer.thumbnailImage
  }
}
